let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("85oXg")).then(() => parcelRequire('8KOQh'));